import type { ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
  crumb?: ReactNode;
}

/** Page title row. Sets document.title via the router's page component. */
export function PageHeader({ title, description, actions, crumb }: PageHeaderProps) {
  return (
    <header className="page-header">
      <div>
        {crumb}
        <h1 className="page-header__title">{title}</h1>
        {description ? <p className="page-header__desc">{description}</p> : null}
      </div>
      {actions ? <div className="page-header__actions">{actions}</div> : null}
    </header>
  );
}
